import type { Material } from '@/stores/type/material.type'

export type CalculationTypeChoiceType = 'DUTCH' | 'GERMAN'
export type CalculationMethodChoiceType = 'HORIZONTAL' | 'SLOPE' | 'QUAY'

export type Calculation = {
  id: number
  project: number
  name: string
  created: string
  modified: string
  favorite: boolean
  status: string
  crosssection_count: number
  currency: string

  material: Material | null

  still_water_level?: number
  vessel: number[]

  main_engine_applied_power?: number
  main_engine_applied_power_range: boolean
  main_engine_applied_power_upper_limit?: number
  main_engine_applied_power_lower_limit?: number
  main_engine_applied_power_step_size?: number

  transverse_thruster_applied_power?: number
  transverse_thruster_applied_power_range: boolean
  transverse_thruster_applied_power_upper_limit?: number
  transverse_thruster_applied_power_lower_limit?: number
  transverse_thruster_applied_power_step_size?: number

  draught?: number
  draught_range: boolean
  draught_upper_limit?: number
  draught_lower_limit?: number
  draught_step_size?: number

  ship_side_distance_side?: number
  ship_side_distance_side_range: boolean
  ship_side_distance_side_upper_limit?: number
  ship_side_distance_side_lower_limit?: number
  ship_side_distance_side_step_size?: number

  ship_side_distance_aft?: number
  ship_side_distance_aft_range: boolean
  ship_side_distance_aft_upper_limit?: number
  ship_side_distance_aft_lower_limit?: number
  ship_side_distance_aft_step_size?: number

  factor_confinement?: number
  factor_confinement_range: boolean
  factor_confinement_upper_limit?: number
  factor_confinement_lower_limit?: number
  factor_confinement_step_size?: number

  angle_flow_attack?: number
  angle_flow_attack_range: boolean
  angle_flow_attack_upper_limit?: number
  angle_flow_attack_lower_limit?: number
  angle_flow_attack_step_size?: number

  main_engine_number?: number
  main_engine_number_range: boolean
  main_engine_number_upper_limit?: number
  main_engine_number_lower_limit?: number
  main_engine_number_step_size?: number

  transverse_thruster_number?: number
  transverse_thruster_number_range: boolean
  transverse_thruster_number_upper_limit?: number
  transverse_thruster_number_lower_limit?: number
  transverse_thruster_number_step_size?: number

  calculation_method?: CalculationTypeChoiceType[]
  calculation_type: CalculationMethodChoiceType

  expected_scour_depth?: number
  expected_scour_depth_range: boolean
  expected_scour_depth_upper_limit?: number
  expected_scour_depth_lower_limit?: number
  expected_scour_depth_step_size?: number

  expected_scour_slope?: number
  expected_scour_slope_range: boolean
  expected_scour_slope_upper_limit?: number
  expected_scour_slope_lower_limit?: number
  expected_scour_slope_step_size?: number

  bed_level?: number
  bed_level_range: boolean
  bed_level_upper_limit?: number
  bed_level_lower_limit?: number
  bed_level_step_size?: number

  bed_gradient?: number
  bed_gradient_range: boolean
  bed_gradient_upper_limit?: number
  bed_gradient_lower_limit?: number
  bed_gradient_step_size?: number

  slope_gradient?: number
  slope_gradient_range: boolean
  slope_gradient_upper_limit?: number
  slope_gradient_lower_limit?: number
  slope_gradient_step_size?: number

  quay_wall_embedment_level?: number
  quay_wall_embedment_level_range: boolean
  quay_wall_embedment_level_upper_limit?: number
  quay_wall_embedment_level_lower_limit?: number
  quay_wall_embedment_level_step_size?: number

  gravity: number
  izbash: number
  german_stability_factor: number
  propfac: number
  mattress_stability_parameter: number
  block_stability_parameter: number
  gabion_stability_parameter: number
  rock_stability_parameter: number
  lift_factor: number
  turbulence_factor: number
  depth_parameter: number
  [key: string]: unknown
}

export const PLAN_VIEW = 'plan_view'
export const CROSS_SECTION = 'cross_section'
export const LENGTH_SECTION = 'length_section'
